export default __webpack_public_path__ + "static/media/Logo.a1d307a3.png";